//sag.worker.js

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {

    function findMaxVoltageDropV2(data, timeSlotInSeconds) {

        // console.log("sag / findMaxVoltageDropV2 / data", data);
        let maxVoltageDrop = 0;
        const tolerance = 200; // 1 millisecond tolerance

        const dataMap = new Map();
        for (let i = 0; i < data.length; i++) {
            const timestamp = parseInt(data[i].date);
            dataMap.set(timestamp, data[i].voltage);
        }

        for (let i = 0; i < data.length; i++) {
            const currentTimestamp = parseInt(data[i].date);
            const aheadTimestamp = currentTimestamp + (timeSlotInSeconds * 1000);

            const currentVoltage = data[i].voltage;
            // console.log("sag / findMaxVoltageDropV2 / currentVoltage", currentVoltage);

            // Find the closest timestamp within the tolerance
            let closestTimestamp;
            for (const timestamp of dataMap.keys()) {
                if (
                    Math.abs(timestamp - aheadTimestamp) <= tolerance &&
                    (closestTimestamp === undefined ||
                        Math.abs(timestamp - aheadTimestamp) <
                        Math.abs(closestTimestamp - aheadTimestamp))
                ) {
                    closestTimestamp = timestamp;
                }
            }

            if (closestTimestamp !== undefined) {
                const twoSecondsAheadVoltage = dataMap.get(closestTimestamp);
                const voltageDrop = currentVoltage - twoSecondsAheadVoltage;
                if (voltageDrop > maxVoltageDrop) {
                    maxVoltageDrop = voltageDrop;
                }
            }
        }

        const ret =  { maxVoltageDrop, timeSlotInSeconds }
        // console.log("sag / findMaxVoltageDropV2 / ret", ret);
        return ret;
    };


    // eslint-disable-next-line no-restricted-globals
    self.onmessage = (message) => {

        // console.log("sag / message", message.data);
        const data = message.data.data;
        // console.log("sag / data", data);
        const timeSlotInSeconds = message.data.timeSlotInSeconds;
        // console.log("sag / timeSlotInSeconds", timeSlotInSeconds);

        let maxVoltageDrop = findMaxVoltageDropV2(data, timeSlotInSeconds);

        postMessage(maxVoltageDrop);
    };
};